export default {
  brand: {
    primary: '#006272',
    secondary: '#72E4D1',
    tertiary: '#FF585D',
    quaternary: '#F6F6F6',
  },
};
